import React from 'react';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';
import { najdarContent } from '../rich-content/najdar-complete-content';

const NajdarDetailPage = () => {
  return <AutomaticPageBuilder content={najdarContent} />;
};

export default NajdarDetailPage;
